import type { Ref } from "vue";
import { useBreakpoint } from "@toolsie/browser";
import { watch, computed } from "vue";

export default function useIsResponsive(
  breakpoint: Ref<number>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  emit: any
): Ref<boolean> {
  const { smaller } = useBreakpoint(breakpoint);
  const isResponsive = computed(() => {
    if (breakpoint.value > 0) {
      return smaller.value;
    } else {
      return false;
    }
  });

  watch(isResponsive, (newValue) => {
    emit("update:responsive", newValue);
  });

  return isResponsive;
}
